<template>
    <div class="top">
      <div class="title">미국주식 실적속보</div>
      <!-- //title -->
      <PCSearch/>
      <div class="t_txt">
        미국주식 실적속보는 씽크풀부터 제공받는 정보이며, 키움증권은 해당정보의 정확성을 보증하지 않습니다. <br>
        새로고침을 누르셔야 최신 정보가 업데이트 됩니다.
      </div>
      <div class="tab">
        <ul>
          <li class="fst" :class="{'on': $route.path.indexOf('aRecord')>-1}"><router-link to="/kw/us/p/aRecord">실적속보</router-link></li>
          <li :class="{'on': $route.path.indexOf('bRecord')>-1}"><router-link to="/kw/us/p/bRecord">예상치 상회/하회</router-link></li>
          <li :class="{'on': $route.path.indexOf('cRecord')>-1}"><router-link to="/kw/us/p/cRecord">흑자/적자 전환</router-link></li>
          <li :class="{'on': $route.path.indexOf('dRecord')>-1}"><router-link to="/kw/us/p/dRecord">EPS 예측치 동향</router-link></li>
          <li :class="{'on': $route.path.indexOf('eRecord')>-1}"><router-link to="/kw/us/p/eRecord">실적발표 캘린더</router-link></li>
        </ul>
      </div>
      <!-- //tab -->

      <div class="btn_g">
        <button @click="goReload">새로고침</button>
        <a href="javascript:;" @click="openToggle">이용안내</a>
        <div class="guide_pop">
          <strong>이용안내</strong>

          <div class="gtbl">
            <span>* 어닝판단에 대한 기준은 아래와 같습니다.</span>

            <table>
              <colgroup>
                <col>
                <col>
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">표기</th>
                  <th scope="col" class="lst">기준</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>어닝서프라이즈</td>
                  <td class="lst">컨센서스 대비 0 ~ +15% 이상</td>
                </tr>
                <tr>
                  <td>예상수준상회</td>
                  <td class="lst">컨센서스 대비 5% ~ 15% 미만</td>
                </tr>
                <tr>
                  <td>예상치부합</td>
                  <td class="lst">컨센서스 대비 -5% ~ 5% 미만</td>
                </tr>
                <tr>
                  <td>예상수준하회</td>
                  <td class="lst">컨센서스 대비 -5% ~ -15% 미만</td>
                </tr>
                <tr class="end">
                  <td>어닝쇼크</td>
                  <td class="lst">컨센서스 대비 -15% 이하</td>
                </tr>
              </tbody>
            </table>

            <span style="padding-top:10px;">* 본 서비스는 속보 서비스로 최근일로부터 약 4개월간의 데이터만 제공됩니다.</span>
          </div>
          <!-- gtbl -->

          <div class="g_txt">
            <strong>이용상의 주의 사항 </strong>

            <span>
              금융시장의 변동에 따라 실적 발표 일정과 공시는 지속적으로 변동됩니다.
              <br><br>
              본 서비스는 미국 실적 공시를 실시간 데이터화 하여 제공함에 있어<br>
              공시의 오류, 데이터 수집 프로세스상의 에러 및 지연 등 다양한 서비스상의<br>
              오류와 지연이 있을 수 있습니다.
              <br><br>
              본 서비스를 이용함에 있어 그 이용에 따르는 책임은 이용자 본인에게 <br>
              있으며, 어떠한 거래 손실이나 다른 손실에 대해서도 책임지지 않습니다.
            </span>
          </div>
          <div class="p_close" @click="closeToggle">
            <img src="https://img.thinkpool.com/concert/us/kiwoom/usRecode/img/p_close.jpg" alt="닫기">
          </div>
        </div>
        <!-- //이용안내 -->

      </div>

    </div>
    <!-- //top -->
</template>

<script>
import PCSearch from '@/components/kiwoom/usRecord/pc/common/Search'
import {mapGetters} from 'vuex'
import { EventBus } from '@/store/event-bus'

export default {
  components: {
    PCSearch
  },
  data () {
    return {
      searchPage: {
        pageNo: 1
      },
      intervalid1: ''
    }
  },
  created () {
    EventBus.$on('pageNo', (val) => {
      this.searchPage.pageNo = val
    })
  },
  computed: {
    ...mapGetters(['getUsRecordSettings']),
    getPageNo () {
      return this.searchPage.pageNo
    }
  },
  methods: {
    todo (intvalData) {
      var data = intvalData * 60 * 1000
      this.intervalid1 = setInterval(function () {
        document.location.reload()
      }, data)
    },
    openToggle () {
      $('.guide_pop').toggle()
    },
    closeToggle () {
      $('.guide_pop').hide()
    },
    goReload () {
      this.$emit('goPage', this.searchPage.pageNo)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/kiwoom/usRecord/pc/common/Header.vue